import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from '@core/auth/authApi';
import { useTenant } from '@core/tenant';
import { useIsAuthenticated } from '@core/auth';

export interface UserProfile {
  name: string;
  email: string;
  phone: string;
  optInEmail: boolean;
  isSocialNetworkUser: boolean;
}

export const userProfileKeys = {
  all: ['userProfile'] as const,
  bySubdomain: (subdomain: string) =>
    [...userProfileKeys.all, subdomain] as const,
};

export function useUserProfile() {
  const { subdomainPrefix } = useTenant();
  const isAuthenticated = useIsAuthenticated();

  return useQuery({
    queryKey: userProfileKeys.bySubdomain(subdomainPrefix!),
    queryFn: async (): Promise<UserProfile> => {
      const response = await getUserInfo(subdomainPrefix!);
      const profile = response.user;
      return {
        name: profile.full_name || '',
        email: profile.user?.email || '',
        phone: profile.phone || '',
        optInEmail: profile.optInEmail ?? false,
        isSocialNetworkUser: response.isSocialNetworkUser ?? false,
      };
    },
    enabled: !!subdomainPrefix && isAuthenticated,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });
}
